module.exports = __webpack_public_path__ + "img/area-limit-btn.87a7f083.png";